import { useMutation as s } from "react-query";
import { useEnvironment as a } from "../../../common/hooks/environment/useEnvironment.js";
class c extends Error {
  constructor(t, r) {
    super(r), this.errorCode = t;
  }
}
function h() {
  const { backendBaseUrl: n } = a();
  return s(async ({
    token: t,
    otpRequestId: r,
    otpCode: i
  }) => {
    const e = await fetch(`${n}/verification/${r}/`, {
      method: "PUT",
      body: JSON.stringify({
        otp_code: i
      }),
      headers: {
        authorization: `Token ${t}`
      }
    });
    if (!e.ok) {
      const o = await e.json().catch(() => ({}));
      throw new c(
        (o == null ? void 0 : o.error_code) ?? "unknown",
        (o == null ? void 0 : o.detail) ?? `Request failed with status ${e.status}`
      );
    }
  });
}
export {
  c as PhoneVerificationConfirmError,
  h as usePhoneVerificationConfirm
};
//# sourceMappingURL=usePhoneVerificationConfirm.js.map
